<!-- Menu.svelte -->
<script>
  import MenuItems from './MenuItems.svelte';
  import MenuItemsSelect from './MenuItemsSelect.svelte';
  import { createEventDispatcher, onMount } from "svelte";
  const dispatch = createEventDispatcher();
  export let menuItems;
  export let categories_sync;
  export let menuLevel = 0;
  export let originalMenuItems;

   
  // Function to toggle the visibility of children
  function toggleChildren(item) {

    item.showChildren = !item.showChildren;

    // if (item.children && item.children.length > 0 && item.showChildren) {

    //   console.log(item.showChildren,item.children.length)

    // }
  }



  function openCategoryBox(event) {

    dispatch('openCategoryBox',event.detail)

  }

  
</script>

<ul>
  {#each menuItems as item (item.id)}
    <li>
      <div on:click={() => toggleChildren(item)}>
        <div class="row">
          <input type="text" bind:value="{item.name}">
          <span style="font-size:14px">קטגורית אב</span>
          <select bind:value={item.parent_id} class="w-[200px]">
            <option value="" selected="selected">ראשי</option>
            <MenuItemsSelect originalMenuItems={originalMenuItems} />
          </select>
          {item.connected_names}
        </div>        
      </div>
      {#if item.children && item.children.length > 0}
      <MenuItems originalMenuItems={originalMenuItems} menuItems={item.children} {categories_sync} {menuLevel} on:openCategoryBox={openCategoryBox}/>
      {/if}
    </li>
  {/each}
</ul>

<style>
  .row {
    padding:5px 0;
  }
  .open_popup_button {
    background-color: #011f53;
    border: 0;
    color: #fff;
    padding: 2px 15px;
    border-radius: 20px;
    cursor: pointer;
    font-size: 12px;
  }
  .connected_categories > span{
    padding: 2px;
    background-color: rgb(205, 216, 255);
    border-radius: 2px;
    /* color: #fff; */
    font-size: 12px;
    padding: 5px;
    margin: 3px;
    display: inline-block;
    cursor:default;
  }
  .connected_categories > span > span{
    border-radius: 50%;
    background-color: #6c79a7;
    width: 18px;
    display: inline-block;
    color: #fff;
    text-align: center;
    cursor: pointer;
  }
  ul {
    list-style: none;
    padding-left: 0;
    padding-right:10px;
  }
  input {
    width:auto;
  }

  li {
    margin-bottom: 5px;
  }

  span {
    cursor: pointer;
  }
</style>
